var _defs, _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5, _path3, _circle6, _path4, _path5, _circle7, _path6, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCommunicationstyle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0f0f0;}.cls-2,.cls-4,.cls-5,.cls-6{fill:none;stroke:#002554;}.cls-2,.cls-6{stroke-linecap:round;}.cls-2,.cls-5{stroke-linejoin:round;}.cls-3{fill:#425cc7;}.cls-4,.cls-6{stroke-miterlimit:10;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 15.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.48,4v-.9a.77.77,0,0,1,.77-.77h9.12a.77.77,0,0,1,.77.77V7.82a.78.78,0,0,1-.77.77h-1V10.5a.35.35,0,0,1-.55.28L20.54,8.59h-.87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.39,5.4H7.63a.77.77,0,0,0-.77.77v4.74a.78.78,0,0,0,.77.78h1V13.6a.34.34,0,0,0,.55.27l2.26-2.18h5.93a.78.78,0,0,0,.78-.78V6.17A.77.77,0,0,0,17.39,5.4Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 12.51,
    cy: 8.52,
    r: 0.74
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 9.63,
    cy: 8.52,
    r: 0.74
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 15.4,
    cy: 8.52,
    r: 0.74
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 8.95,
    cy: 19.71,
    r: 2.33
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10,23.59A3.31,3.31,0,0,0,9,23.41H9a3.18,3.18,0,0,0-3.17,3.17v.9H9.62"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 22.77,
    cy: 19.72,
    r: 2.33
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.73,23.59a3.31,3.31,0,0,1,1.05-.18h0a3.18,3.18,0,0,1,3.16,3.17v.9H22.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.42,24a3.28,3.28,0,0,0-3.28-3.28h0A3.28,3.28,0,0,0,12.86,24v3.47h6.56Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 15.86,
    cy: 16.34,
    r: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M20,24.81a4.1,4.1,0,0,0-4.09-4.08h0a4.1,4.1,0,0,0-4.08,4.08v2.67H20Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3,
    y1: 27.48,
    x2: 29,
    y2: 27.48
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommunicationstyle);
export default __webpack_public_path__ + "static/media/icon-communicationstyle.8946083cbc18c8df916f3c014f9cfca1.svg";
export { ForwardRef as ReactComponent };